import React, { Component } from 'react';
import { connect } from 'react-redux';
import { authorizeIssueDispute, createOrUpdateIssueDispute } from 'actions/issueDisputeActions';
import Loading from 'components/Loading/Loading';

import IssueAppointmentSummary from '../../IssueAppointmentSummary';

import './style.css';

class DisputeIssue extends Component {
  constructor() {
    super();
    this.state = {
      reason: ''
    };
  }

  componentWillMount() {
    const { id, secret } = this.props.routeParams;
    this.props.authorizeIssueDispute(id, secret);
  }

  handleReasonChange = (e) => {
    this.setState({ reason: e.target.value });
  }

  handleSubmit = () => {
    const { id, secret } = this.props.routeParams;
    this.props.createOrUpdateIssueDispute(id, secret, this.state.reason);
  }

  isSubmitDisabled = () => {
    return this.props.issueDispute.status === 'SUBMITTING';
  }

  render() {
    if (
      this.props.issueDispute.status === 'READY' &&
      this.props.issueDispute.authorized === true &&
      this.props.issueDispute.existingDispute &&
      this.props.issueDispute.existingDispute.reason.length > 0 &&
      this.state.reason === ''
    ) {
      this.setState({ reason: this.props.issueDispute.existingDispute.reason });
    }

    const showForm =
      this.props.issueDispute.status === 'SUBMITTING' ||
      (this.props.issueDispute.status === 'READY' && this.props.issueDispute.authorized === true);

    return (
      <div className="DisputeIssue d-flex justify-content-center">
        <div className="card mb-4 mt-4">
          {(this.props.issueDispute.status === 'LOADING' ||
            this.props.issueDispute.status === null) && <Loading />}

          {showForm && (
            <div>
              <form>
                <div className="title mb-4">Dispute</div>
                <p>Please tell us why you are disputing this refund request</p>
                <textarea
                  value={this.state.reason}
                  className="form-control"
                  rows="8"
                  placeholder=""
                  onChange={this.handleReasonChange}
                />
                <div className="mt-4">
                  <button
                    className="btn btn-primary"
                    type="button"
                    disabled={this.isSubmitDisabled()}
                    onClick={this.handleSubmit}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          )}

          {this.props.issueDispute.status === 'READY' &&
            this.props.issueDispute.authorized === false && (
              <div>
                <div className="title mb-4">Sorry</div>

                {this.props.issueDispute.reason === 'already_approved' && (
                  <div>
                    <p>
                      This issue has already been approved and the credit returned to the student.
                    </p>
                    <p>
                      You cannot dispute a previously approved request but you can email{' '}
                      <a href="mailto:help@rypeapp.com">help@rypeapp.com</a> with any questions or
                      comments about this.
                    </p>
                  </div>
                )}

                {this.props.issueDispute.reason === 'already_denied' && (
                  <p>
                    Rype has already denied your student&#39;s request for their credit back. You have
                    nothing to do here.
                  </p>
                )}
              </div>
          )}

          {this.props.issueDispute.status === 'CREATED' && (
            <div>
              <div className="title mb-4">Dispute Submitted</div>
              <p>
                Your dispute has been submitted. A member from customer support will review the
                dispute and notify you of the results.
              </p>
            </div>
          )}

          {(this.props.issueDispute.status === 'FAIL' ||
            this.props.issueDispute.status === 'UNAUTHORIZED') && (
            <div>
              <div className="title error mb-4">Error</div>
              <p>
                {this.props.issueDispute.error.message || 'An unexpected problem was experienced'}
              </p>
            </div>
          )}

          {this.props.issueDispute.appointment && (
            <IssueAppointmentSummary
              issue={this.props.issueDispute.issue}
              appointment={this.props.issueDispute.appointment}
            />
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    issueDispute: state.issueDispute
  };
}

export default connect(
  mapStateToProps,
  { authorizeIssueDispute, createOrUpdateIssueDispute }
)(DisputeIssue);



// WEBPACK FOOTER //
// ./src/pages/student/ReportIssue/routes/DisputeIssue/index.js